var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHobby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4007_719)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4007_719)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.162 8.90687C44.446 17.8225 42.8638 30.0647 34.5188 37.0889C26.1739 44.113 13.8411 43.5844 6.12829 35.8716C-1.58451 28.1588 -2.11385 15.826 4.91101 7.48032C11.9352 -0.863922 24.1774 -2.44689 33.093 3.83791L38.162 8.90687Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6143 10.1381C39.4675 16.9334 38.8976 27.1409 32.3239 33.2432C25.7509 39.3448 15.529 39.155 9.18768 32.813C2.84496 26.4711 2.65523 16.2491 8.75682 9.67612C14.8584 3.1024 25.0666 2.5325 31.8619 8.3857",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 33.3101C27.7986 33.3101 33.3101 27.7986 33.3101 20.9998C33.3101 14.201 27.7986 8.68945 20.9998 8.68945C14.201 8.68945 8.68945 14.201 8.68945 20.9998C8.68945 27.7986 14.201 33.3101 20.9998 33.3101Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 28.9652C25.3989 28.9652 28.9652 25.3989 28.9652 20.9997C28.9652 16.6005 25.3989 13.0342 20.9997 13.0342C16.6005 13.0342 13.0342 16.6005 13.0342 20.9997C13.0342 25.3989 16.6005 28.9652 20.9997 28.9652Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 24.6203C22.9997 24.6203 24.6208 22.9992 24.6208 20.9996C24.6208 18.9999 22.9997 17.3789 21.0001 17.3789C19.0004 17.3789 17.3794 18.9999 17.3794 20.9996C17.3794 22.9992 19.0004 24.6203 21.0001 24.6203Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9308 5.06897H41.9997L36.9308 10.1379H31.8618V5.06897L36.9308 0V5.06897Z",
    fill: "#C03A2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 21.7242C20.8567 21.7242 20.7167 21.6817 20.5976 21.6021C20.4786 21.5226 20.3858 21.4095 20.331 21.2772C20.2762 21.1449 20.2619 20.9993 20.2898 20.8588C20.3177 20.7184 20.3867 20.5894 20.4879 20.4881L39.3155 1.66052C39.3823 1.59136 39.4622 1.53619 39.5505 1.49824C39.6389 1.46029 39.7339 1.44032 39.8301 1.43948C39.9262 1.43864 40.0216 1.45697 40.1106 1.49338C40.1995 1.52979 40.2804 1.58356 40.3484 1.65155C40.4164 1.71954 40.4701 1.80039 40.5066 1.88938C40.543 1.97838 40.5613 2.07373 40.5605 2.16988C40.5596 2.26603 40.5396 2.36106 40.5017 2.4494C40.4637 2.53775 40.4086 2.61766 40.3394 2.68445L21.5118 21.512C21.3761 21.6479 21.1919 21.7242 20.9999 21.7242Z",
    fill: "#A56A43"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4007_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4007_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobby);
export default __webpack_public_path__ + "static/media/hobby.610eeef4ad184712965c1d55d6e0df63.svg";
export { ForwardRef as ReactComponent };